angular.module('sharecrf.login-info', [
    'event',
    'user',
]);